import { Category } from 'src/types';

const BLACK_LIST = [
  '1497', // (Trainers & Casual shoes)
  '1428', // (Runing shoes)
  '1739', //  Children's Trainers & casual shoes)
  '1520', //  (Indoor sport shoes)
  '812', //  (Football shoes)
];

export const isBlacklistedForColors = (category?: Category | null) => {
  return Boolean(
    category?.path?.length &&
      category?.path?.some(categoryPath => BLACK_LIST.includes(categoryPath.id))
  );
};
